import React, { useState, useMemo } from 'react';
import { AccordeonMail } from './StageParametrageContacts';
import { stageAPI } from '../services/api';
import { COURRIELS_CERTIF as MODELES } from '../services/modelesCourrielPresentation';

/**
 * SUIVI DE STAGE — Certification › Paramétrage › Modèles de courriel (lot C.0 bis)
 * ================================================================================
 * Spec     : doc/modules/suivi_de_stage_certification.md § 2 b) — C33
 * Maquette : #cpc-modeles — trois accordéons
 *
 * ── LES MÊMES RÈGLES QUE STAGIAIRES → CONTACTS, TELLES QU'ELLES SONT CODÉES ──
 * C'est le MÊME composant (`AccordeonMail`, exporté par Contacts) : destinataires
 * À / Cc / Cci, objet ≤ 300, variables insérées au curseur, commentaire, colonne
 * Versions et « Restaurer », saisie qui survit au redessin. Mêmes tables, mêmes
 * routes (`/modeles-mail/:type`) : le serveur relit la famille du modèle.
 * Ne change ici que ce qui est propre à la certification : à quoi sert chaque
 * modèle, ses variables, et ce que devient {lien} (SMTP seulement, C31).
 *
 * ⚠️ Pas de liste de contacts dans cet onglet (Bertrand, 2026-10-03) : les cases
 * « Cc responsables » et « Cc assistantes » visent les personnes désignées dans
 * Stagiaires → Paramétrage → Contacts.
 */

// Lot MC (2026-10-28) : la description vit dans services/modelesCourrielPresentation.js (lue aussi par les fenêtres d'envoi).

function StageCertifModeles({ donnees, departementId, modifiable, onMiseAJour, processusId = null }) {
    const [ouvert, setOuvert] = useState(null);
    // L2b (E170, v88) : dans une vignette, chaque courriel est celui de CE processus — les trois appels le portent.
    const apiProcessus = useMemo(() => (processusId ? {
        enregistrerModeleMail: (t, d, data) => stageAPI.enregistrerModeleMail(t, d, data, null, processusId),
        listerVersionsMail: (t, d) => stageAPI.listerVersionsMail(t, d, null, processusId),
        restaurerVersionMail: (t, v, d) => stageAPI.restaurerVersionMail(t, v, d, null, processusId)
    } : null), [processusId]);
    const modeles = donnees.modeles_mail || [];

    return (
        <>
            <div style={{ fontSize: 12, color: 'var(--stg-muted)', marginBottom: 12 }}>
                <i className="fa-solid fa-circle-info" /> Mêmes règles que Stagiaires → Paramétrage → Courriels. Les messages partent
                {' '}au nom de l'assistante (« via DptQLIO Manager ») ; une modification vaut pour les prochains envois — le journal
                {' '}garde le texte réellement envoyé. Les copies visent les personnes désignées dans Paramétrage général → Équipe.
            </div>

            {modeles.length === 0 && (
                <div className="stg-encart stg-encart-erreur">
                    <i className="fa-solid fa-circle-exclamation" />
                    <span>Aucun modèle de courriel de la certification pour ce département : la migration v55 n'a pas été jouée.</span>
                </div>
            )}

            {modeles.map((m) => {
                const c = MODELES[m.type_mail] || {};
                return (
                    <AccordeonMail
                        key={m.type_mail}
                        modele={m}
                        ouvert={ouvert === m.type_mail}
                        onBasculer={() => setOuvert(ouvert === m.type_mail ? null : m.type_mail)}
                        departementId={departementId}
                        modifiable={modifiable}
                        onMiseAJour={onMiseAJour}
                        icone={c.icone}
                        destinataire={c.destinataire}
                        sousTitre={c.sousTitre}
                        variables={c.variables}
                        noteLien={c.noteLien}
                        noteDestinataires="En envoi collectif, une personne en copie reçoit un seul exemplaire."
                        api={apiProcessus}
                    />
                );
            })}
        </>
    );
}

export default StageCertifModeles;
